<div #custom_dialog_container
  cdkDrag
  [cdkDragDisabled]="!isDraggable(config?.component)"
  [cdkDragRootElement]="'.mat-mdc-dialog-container'"
  class="dialog-drag-container">
  @if (config) {
    @if (componentType) {
      <ng-container *ngComponentOutlet="componentType; inputs: componentInputs"></ng-container>
    } @else {
      @if (config.component==='CommentComponent') {
        <textarea [innerText]="config.parameters || ''" (change)="updateText($event)" placeholder="Comment..."></textarea>
      }
      @if (config.component==='ColumnWidth') {
        <div class="column-width-input">
          <label>{{config.parameters.title}}:</label>
          <input matInput (input)="updateSeriesSummary(config.parameters.width)"
            [(ngModel)]="config.parameters.width"
            [max]="1200" [min]="20" name="width"
            step="1" type="number">
        </div>
      }
    }
    @if (config.show_close) {
      <div (click)="onCloseClick()" class="action-buttons">
        <div class="btn-close">Close</div>
      </div>
    }
  }
</div>
